//制造业重大项目方向

const indexAdmin = () => import('./indexAdmin');
const indexAppl = () => import(/* webpackChunkName: "herb" */ './indexAppl');
const edit = () => import('./edit.vue');

export default {
  routes: [
    {
      path: '/park/v2024/indexAppl',
      name: 'park_v2024_index_appl',
      component: indexAppl,
      meta:{public:true}
    },
    {
      path: '/park/v2024/indexAdmin',
      name: 'park_v2024_index_admin',
      component: indexAdmin,
      meta: {public: true}
    },
    {
      path: '/park/v2024/edit',
      name: 'park_v2024_edit',
      component: edit,
      meta: {public: true}
    },
  ]
}



// WEBPACK FOOTER //
// ./src/components/special/parkproject/v2024/router.js